<script setup lang="ts">
const props = defineProps<{
  title: string;
  subtitle?: string;
}>();
</script>

<template>
  <div>
    <h2 class="font-semibold text-lg">
      {{ props.title }}
    </h2>
    <p v-if="props.subtitle" class="mt-2 pb-4 text-sm border-b">
      {{ props.subtitle }}
    </p>
  </div>
</template>
